var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEosSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 32,
    viewBox: "0 0 88 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9362 45.0024V65.0064L9.27502 70.0007V40.0013L17.9362 45.0024Z",
    fill: "#FFA534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2224 25.0017V75.0017L78.5612 80.0027L78.5578 40.0013L69.9 44.999V85.0037L43.9164 100V50.0034L52.5776 45.0024V85.0037L61.2388 80.0027V40.0013L87.2224 25.0017Z",
    fill: "#FFA534"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5974 19.9973L17.9362 24.9983L26.5974 29.9993V19.9973Z",
    fill: "#FFA534"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9165 9.99866L35.2552 14.9997L43.9165 19.9973V9.99866Z",
    fill: "#FFA534"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2224 25.0017L78.5612 29.9993L43.9164 9.99865L35.2552 14.9997V15.003L43.9164 19.9973L69.9 35.0003L61.2422 40.0014H61.2388V39.998L26.5974 19.9973L17.9362 24.9983L52.5776 45.0024L43.9164 50.0034L0.61377 24.9983L43.913 0H43.9164L87.2224 25.0017Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2552 75.0017V85.0037L9.27502 70.0007L17.9362 65.0064L35.2552 75.0017Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5776 85.0037L61.2388 80.0027L52.5776 75.0017V85.0037Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.61377 24.9983V75.0017L43.9164 100V49.9966L0.61377 24.9983ZM35.2552 85.0037L9.27159 70.0007V40.0014L35.2552 55.0044V85.0037Z",
    fill: "#FF6C2D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5612 80.0027L69.9 75.0017V44.999L78.5578 40.0013L78.5612 80.0027Z",
    fill: "#FF6C2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5612 29.9993L69.9 35.0004L43.9164 19.9973V9.99866L78.5612 29.9993Z",
    fill: "#FF6C2D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5974 19.9973V29.9993L52.5776 45.0024V75.0017L61.2388 80.0027V40.0013L26.5974 19.9973Z",
    fill: "#FF6C2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEosSymbol);
export default __webpack_public_path__ + "static/media/EOS-symbol.c9d0ec02bf556f91403522b5976ba701.svg";
export { ForwardRef as ReactComponent };